import React from 'react'
import styles from './SliderItem.module.scss'
import classNames from 'classnames'
import { message, Popconfirm } from 'antd';
import i18n from '../../../../../../lib/i18n';
import { FaTimes, FaCog, FaPencilAlt, FaLink, FaEye } from 'react-icons/fa'

import { deleteSlider } from '../../../../actions';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import sign from 'jwt-encode';
import ShareModal from './components/ShareModal/ShareModal';

function SliderItem({ slider = {} }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className={classNames(styles.SliderItem, 'col-md-4')}>
      <div className={styles.card}>
        {/* ─── Preview Area ─────────────────────────────────────── */}
        <div className={styles.preview} onClick={() => navigate('/slider/' + slider.id)}>
          <div
            className={styles.previewBg}
            style={{ backgroundImage: slider.first_slider ? `url(${slider.first_slider.src})` : 'none' }}
          />

          {/* Top actions (hover reveal) */}
          <div className={styles.topActions}>
            <div className={styles.topBtn} onClick={(e) => {
              e.stopPropagation();
              navigate('/slider/' + slider.id)
            }}>
              <FaCog />
            </div>
            <div className={classNames(styles.topBtn, styles.deleteBtn)} onClick={(e) => {
              e.stopPropagation();
            }}>
              <Popconfirm
                title={i18n('pr_title_destory')}
                description={i18n('pr_msg_destory')}
                onConfirm={() => {
                  dispatch(deleteSlider(slider.id))
                }}
                okText={i18n("Yes")}
                cancelText={i18n("No")}
              >
                <FaTimes />
              </Popconfirm>
            </div>
          </div>
        </div>

        {/* ─── Card Body ───────────────────────────────────────── */}
        <div className={styles.body}>
          <div className={styles.title} title={slider.name}>{slider.name}</div>
        </div>

        {/* ─── Action Bar ──────────────────────────────────────── */}
        <div className={styles.actionBar}>
          <div className={styles.actionBtn} onClick={(e) => {
            e.stopPropagation();
            const link = window.location.origin + '/slider/view/' + sign({ id: slider.id }, 'qbm31');
            navigator.clipboard.writeText(link).then(() => {
              message.success(i18n('linkMsgCopy'));
            }).catch(() => {
              message.error(i18n('sl_copy_failed'));
            });
          }} title={i18n('sl_copy_link')}>
            <FaLink />
          </div>

          <div className={styles.actionBtn} onClick={(e) => e.stopPropagation()} title={i18n('sl_share')}>
            <ShareModal slider={slider} />
          </div>

          <a
            href={'/slider/view/' + sign({ id: slider.id }, 'qbm31')}
            target='_blank'
            className={styles.actionBtn}
            onClick={(e) => e.stopPropagation()}
            title={i18n('sl_preview')}
          >
            <FaEye />
          </a>

          <div className={styles.actionBtn} onClick={(e) => {
            e.stopPropagation();
            dispatch({ type: 'SET_SLIDERS_KEY', key: 'isShowModal', data: true })
            dispatch({ type: 'SET_SLIDERS_KEY', key: 'item', data: slider })
          }} title={i18n('sl_edit')}>
            <FaPencilAlt />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderItem